<template>
    <div class="mx-auto max-w-7xl">
        <div class="mx-6 border-b border-gray-200 pb-5">
            <h3 class="text-3xl font-bold leading-6 text-gray-900">
                {{ title }}
            </h3>
        </div>
        <div class="bg-white py-12 sm:py-24">
            <div class="mx-auto grid max-w-7xl grid-cols-1 gap-x-8 gap-y-12 px-6 sm:gap-y-16 lg:grid-cols-2 lg:px-8">
                <article class="mx-auto w-full max-w-2xl lg:mx-0 lg:max-w-lg">
                    <div class="flex gap-1">
                        <Tag v-for="tag in getTags(featuredPost.tags)" :tag="tag" :key="tag" />
                    </div>
                    <h2 id="featured-post" class="mt-4 text-xl font-semibold tracking-tight text-gray-900 sm:text-3xl">
                        <Link :href="route('blog.show', featuredPost.slug)">
                            {{ featuredPost.title }}
                        </Link>
                    </h2>
                    <p class="mt-4 text-lg leading-8 text-gray-600">
                        {{ featuredPost.description }}
                    </p>
                    <div
                        class="mt-4 flex flex-col justify-between gap-6 sm:mt-8 sm:flex-row-reverse sm:gap-8 lg:mt-4 lg:flex-col"
                    >
                        <div class="flex">
                            <Link
                                :href="route('blog.show', featuredPost.slug)"
                                class="text-sm font-semibold leading-6 text-sky-600"
                                aria-describedby="featured-post"
                                >Weiterlesen <span aria-hidden="true">&rarr;</span></Link
                            >
                        </div>
                    </div>
                </article>
                <div
                    class="mx-auto w-full max-w-2xl border-t border-gray-900/10 pt-12 sm:pt-16 lg:mx-0 lg:max-w-none lg:border-t-0 lg:pt-0"
                >
                    <div class="-my-12 divide-y divide-gray-900/10">
                        <article v-for="post in remainingPosts" :key="post.id" class="py-12">
                            <div class="group relative max-w-xl">
                                <div class="flex gap-1">
                                    <Tag v-for="tag in getTags(post.tags)" :tag="tag" :key="tag" />
                                </div>
                                <h2 class="mt-2 text-lg font-semibold text-gray-900 group-hover:text-gray-600">
                                    <Link :href="route('blog.show', post.slug)">
                                        <span class="absolute inset-0" />
                                        {{ post.title }}
                                    </Link>
                                </h2>
                                <p class="mt-4 text-sm leading-6 text-gray-600">
                                    {{ post.description }}
                                </p>
                            </div>
                            <div class="relative mt-4 flex items-center gap-x-4">
                                <time :datetime="post.published_at" class="text-sm text-gray-500">{{
                                    Intl.DateTimeFormat('de-DE', {
                                        year: 'numeric',
                                        month: 'long',
                                        day: '2-digit',
                                    }).format(new Date(post.published_at))
                                }}</time>
                            </div>
                        </article>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import Tag from '../Fragments/CategoryTag.vue'
import { Link } from '@inertiajs/vue3'

const props = defineProps({
    title: String,
    posts: Array,
})

function getTags(tags) {
    return tags.map((o) => o['slug'])
}

const featuredPost = computed(() => props.posts[0])
const remainingPosts = computed(() => props.posts.slice(1))
</script>
